var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6296 3.45753C15.2465 3.07428 14.7917 2.77026 14.2911 2.56284C13.7905 2.35542 13.254 2.24866 12.7121 2.24866C12.1702 2.24866 11.6337 2.35542 11.1331 2.56284C10.6325 2.77026 10.1777 3.07428 9.7946 3.45753L8.9996 4.25253L8.2046 3.45753C7.43083 2.68376 6.38138 2.24906 5.2871 2.24906C4.19283 2.24906 3.14337 2.68376 2.3696 3.45753C1.59583 4.2313 1.16113 5.28075 1.16113 6.37503C1.16113 7.4693 1.59583 8.51876 2.3696 9.29253L3.1646 10.0875L8.9996 15.9225L14.8346 10.0875L15.6296 9.29253C16.0128 8.90946 16.3169 8.45464 16.5243 7.95404C16.7317 7.45345 16.8385 6.91689 16.8385 6.37503C16.8385 5.83316 16.7317 5.2966 16.5243 4.79601C16.3169 4.29542 16.0128 3.84059 15.6296 3.45753Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.cf2d9f20e8ed9b3b3a5f16fabc6dfeaf.svg";
export { ForwardRef as ReactComponent };